import _, { isEmpty } from 'lodash'
import { MEDIA_DISPLAY_STATE } from './const/mediaDisplayState'

const sentimentValues = { negative: 'lessThan', neutral: 'equals', positive: 'greaterThan' }

export const composeContactSearchParamData = data => {
  let paramValue
  return data.reduce((paramObj, filter) => {
    switch (filter.id) {
      case 'calibrated':
        paramObj['completedCalibration'] = filter.fields.completedCalibration ? 'true' : 'false'
        break
      case 'dateEvaluated':
        if (isEmpty(filter.fields.dateEvaluatedStart) || isEmpty(filter.fields.dateEvaluatedEnd)) {
          break
        }
        paramObj['dateEvaluatedStart'] = `${filter.fields.dateEvaluatedStart}T00:00:00`
        paramObj['dateEvaluatedEnd'] = `${filter.fields.dateEvaluatedEnd}T23:59:59`
        break
      case 'evalState':
        paramValue = Object.keys(filter.fields)
          .filter(key => filter.fields[key] !== false)
          .join(',')

        if (paramValue !== '') {
          paramObj['evalState'] = paramValue
        }
        break
      case 'score':
        if (isEmpty(filter.fields.score)) {
          break
        }
        paramValue = `score~${filter.fields.scoreOperator}~${filter.fields.score}`

        if (Array.isArray(paramObj['expr'])) {
          paramObj['expr'].push(paramValue)
        } else {
          paramObj['expr'] = [paramValue]
        }
        break
      case 'specificDate':
        if (isEmpty(filter.fields.beginDate) || isEmpty(filter.fields.endDate)) {
          break
        }
        paramObj['beginDate'] = filter.fields.beginDate
        paramObj['endDate'] = filter.fields.endDate
        break
      case 'surveyName':
        if (filter.fields.surveyId !== 'all') {
          paramObj['surveyId'] = filter.fields.surveyId
        }
        break
      case 'surveyScore':
        if (isEmpty(filter.fields.surveyScore_value)) {
          break
        }
        paramValue = `surveyScore~${filter.fields.surveyScore_operator}~${filter.fields.surveyScore_value}`

        if (Array.isArray(paramObj['expr'])) {
          paramObj['expr'].push(paramValue)
        } else {
          paramObj['expr'] = [paramValue]
        }
        break
      case 'timeRange':
        if (isEmpty(filter.fields.beginTime) || isEmpty(filter.fields.endTime)) {
          break
        }
        paramObj['beginTime'] = filter.fields.beginTime
        paramObj['endTime'] = filter.fields.endTime
        break
      case 'evalResponse':
        paramValue = Object.keys(filter.fields)
          .reduce((acc, key) => {
            if (filter.fields[key]) {
              if (key === 'evalResponse_pending') {
                acc.push(1)
              } else if (key === 'evalResponse_acknowledged') {
                acc.push(2)
              } else if (key === 'evalResponse_appealed') {
                acc.push(3)
              }
            }
            return acc
          }, [])
          .join(',')

        if (paramValue !== '') {
          paramObj['evalResponseStateId'] = paramValue
        }
        break
      case 'duration':
        if (isEmpty(filter.fields.value)) {
          break
        }
        paramValue = `duration~${filter.fields.operator}~${filter.fields.value}`

        if (Array.isArray(paramObj['expr'])) {
          paramObj['expr'].push(paramValue)
        } else {
          paramObj['expr'] = [paramValue]
        }
        break
      case 'email':
        if (!isEmpty(filter.fields.toAddress)) {
          paramObj['toAddress'] = `*${filter.fields.toAddress}*`
        }
        if (!isEmpty(filter.fields.fromAddress)) {
          paramObj['fromAddress'] = `*${filter.fields.fromAddress}*`
        }
        if (!isEmpty(filter.fields.subject)) {
          paramObj['subject'] = `*${filter.fields.subject}*`
        }
        break
      case 'event':
        if (isEmpty(filter.fields.eventVal)) {
          break
        }
        paramValue = `${filter.fields.eventType}~${filter.fields.eventOperator}~${filter.fields.eventVal}`

        if (Array.isArray(paramObj['expr'])) {
          paramObj['expr'].push(paramValue)
        } else {
          paramObj['expr'] = [paramValue]
        }
        break
      case 'sentiment':
        paramValue = `sentiment~${sentimentValues[filter.fields.sentiment]}~0`

        if (Array.isArray(paramObj['caa'])) {
          paramObj['caa'].push(paramValue)
        } else {
          paramObj['caa'] = [paramValue]
        }
        break
      case 'organization':
        if (filter.fields.group !== 'all') {
          paramObj['group'] = filter.fields.group
        }
        if (filter.fields.team !== 'all') {
          paramObj['team'] = filter.fields.team
        }
        if (filter.fields.agent !== 'all') {
          paramObj['agent'] = filter.fields.agent
        }
        break
      case 'pnps': // Predictive Net Promoter Score
      case 'peval': // Predictive Quality Score
        if (isEmpty(filter.fields.value)) {
          break
        }
        paramValue = `${filter.id}~${filter.fields.operator}~${filter.fields.value}`

        if (Array.isArray(paramObj['caa'])) {
          paramObj['caa'].push(paramValue)
        } else {
          paramObj['caa'] = [paramValue]
        }
        break
      case 'metadata':
        //Don't submit data if there is no metadata value
        if (isEmpty(filter.fields.value)) {
          break
        }
        paramValue = `${encodeURIComponent(filter.fields.key)}~${filter.fields.operator}~${filter.fields.value}`

        if (Array.isArray(paramObj['metadata'])) {
          paramObj['metadata'].push(paramValue)
        } else {
          paramObj['metadata'] = [paramValue]
        }
        break
      case 'contactId':
        if (filter.fields.contactId !== '') {
          paramObj['contactId'] = parseInt(filter.fields.contactId, 10)
        }
        break
      case 'textSearch':
        if (filter.fields.searchText !== '') {
          paramObj['searchText'] = filter.fields.searchText
        }
        if (Array.isArray(filter.fields.textSearchDocumentTypes) && filter.fields.textSearchDocumentTypes.length > 0) {
          paramObj['textSearchDocumentTypes'] = Array.from(filter.fields.textSearchDocumentTypes).join(',')
        }
        // ignoreSearchTextLocal is a way of controlling Stemming in opensearch
        // the standard analyzer is used if locale is not specified i.e. searchTextLocale (workitem 936534)
        if (filter.fields.searchTextLocale !== '' && filter.fields.ignoreSearchTextLocal !== true) {
          paramObj['searchTextLocale'] = filter.fields.searchTextLocale
        }
        break
      case 'externalParty':
        if (filter.fields.externalParty !== '') {
          paramObj['externalParty'] = filter.fields.externalParty
        }
        break
      default:
        Object.keys(filter.fields).forEach(key => {
          // don't include false or empty fields
          if (filter.fields[key] !== false && filter.fields[key] !== '' && filter.fields[key] !== null) {
            paramObj[key] = filter.fields[key]
          }
        })
    }
    return paramObj
  }, {})
}

export const composeMostRecentSearchData = data => {
  let exprIndex = 0
  let caaIndex = 0
  let metaIndex = 0
  return data.reduce((paramObj, filter) => {
    switch (filter.id) {
      case 'calibrated':
        paramObj['completedCalibration'] = filter.fields.completedCalibration ? 'true' : 'false'
        break
      case 'evalState':
        Object.keys(filter.fields).forEach(key => {
          if (filter.fields[key] !== false) {
            paramObj[key] = filter.fields[key]
          }
        })
        break
      case 'score':
        paramObj[`expr_${exprIndex++}`] = `score~${filter.fields.scoreOperator}~${filter.fields.score}`
        break
      case 'surveyName':
        paramObj['surveyId'] = filter.fields.surveyId
        break
      case 'surveyScore':
        paramObj[
          `expr_${exprIndex++}`
        ] = `surveyScore~${filter.fields.surveyScore_operator}~${filter.fields.surveyScore_value}`
        break
      case 'evalResponse':
        Object.keys(filter.fields).forEach(key => {
          if (filter.fields[key] !== false) {
            paramObj[key] = filter.fields[key]
          }
        })
        break
      case 'duration':
        paramObj[`expr_${exprIndex++}`] = `duration~${filter.fields.operator}~${filter.fields.value}`
        break
      case 'event':
        paramObj[
          `expr_${exprIndex++}`
        ] = `${filter.fields.eventType}~${filter.fields.eventOperator}~${filter.fields.eventVal}`
        break
      case 'sentiment':
        paramObj[`caa_${caaIndex++}`] = `sentiment~${sentimentValues[filter.fields.sentiment]}~0`
        break
      case 'pnps': // Predictive Net Promoter Score
      case 'peval': // Predictive Evaluation Score
        paramObj[`caa_${caaIndex++}`] = `${filter.id}~${filter.fields.operator}~${filter.fields.value}`
        break
      case 'metadata':
        paramObj[`meta_${metaIndex++}`] = `${encodeURIComponent(filter.fields.key)}~${filter.fields.operator}~${filter.fields.value}`
        break
      case 'contactId':
        paramObj['contactId'] = filter.fields.contactId === '' ? '' : parseInt(filter.fields.contactId, 10)
        break
      default:
        Object.keys(filter.fields).forEach(key => {
          if (filter.fields[key] !== false) {
            paramObj[key] = filter.fields[key]
          }
        })
    }
    return paramObj
  }, {})
}

export const parseFilterData = data => {
  let filterList = []

  if (!data) {
    return filterList
  }

  const updateFilterList = (updatedFilter, filterList) => {
    let updated = false

    // update filter with new fields property if it already exists
    const updatedFilterList = filterList.map(filter => {
      const newFilter = { ...filter }
      if (filter.id === updatedFilter.id) {
        newFilter.fields = { ...filter.fields, ...updatedFilter.fields }
        updated = true
      }
      return newFilter
    })

    if (!updated) {
      // this is a new filter to add
      updatedFilterList.push(updatedFilter)
    }

    return updatedFilterList
  }

  const keys = Object.keys(data)
  keys.forEach(key => {
    let filter = null
    switch (key) {
      case 'approverFirstName':
      case 'approverLastName':
        filter = {
          id: 'approvedBy',
          title: 'approvedBy',
        }
        break
      case 'assocCallId':
        filter = {
          id: 'associatedCallId',
          title: 'associatedContactId',
        }
        break
      case 'avayaDecimalUCID':
        filter = {
          id: 'avayaDecUCID',
          title: 'avayaDecimalUCID',
        }
        break
      case 'completedCalibration':
        filter = {
          id: 'calibrated',
          title: 'calibrated',
          fields: {
            completedCalibration: JSON.parse(data['completedCalibration']),
          },
        }
        break
      case 'callDirection':
        filter = {
          id: 'callDirection',
          title: 'direction',
        }
        break
      case 'contactId':
        filter = {
          id: 'contactId',
          title: 'contactId',
        }
        break
      case 'contactType':
        filter = {
          id: 'contactType',
          title: 'contactType',
        }
        break
      case 'dateEvaluatedStart':
      case 'dateEvaluatedEnd':
        filter = {
          id: 'dateEvaluated',
          title: 'dateEvaluated',
        }
        break
      case 'evalForm':
        filter = {
          id: 'evalForm',
          title: 'evaluationForm',
        }
        break
      case 'range':
        filter = {
          id: 'dateRange',
          title: 'dateRange',
        }
        break
      case 'toAddress':
      case 'fromAddress':
      case 'subject':
        filter = {
          id: 'email',
          title: 'email',
        }
        break
      case 'evaluatorFirstName':
      case 'evaluatorLastName':
        filter = {
          id: 'evaluatorName',
          title: 'evaluatorName',
        }
        break
      case 'group':
      case 'team':
      case 'agent':
        filter = {
          id: 'organization',
          title: 'organization',
        }
        break
      case 'line':
        filter = {
          id: 'line',
          title: 'callLine',
        }
        break
      case 'phoneNumber':
        filter = {
          id: 'phoneNumber',
          title: 'phoneNumber',
        }
        break
      case 'recordingType':
        filter = {
          id: 'recordingType',
          title: 'recordingType',
        }
        break
      case 'hasVoice':
      case 'hasScreen':
      case 'hasSurvey':
      case 'hasTranscription':
      case 'hasText':
        filter = {
          id: 'contactContent',
          title: 'contactContent',
        }
        break
      case 'tagged':
      case 'hr':
      case 'training':
        filter = {
          id: 'recordingFlags',
          title: 'recordingFlags',
        }
        break
      case 'searchScope':
        filter = {
          id: 'searchScope',
          title: 'searchScope',
        }
        break
      case 'beginDate':
      case 'endDate':
        filter = {
          id: 'specificDate',
          title: 'specificDate',
        }
        break
      case 'scored':
      case 'unscored':
      case 'cannot_score':
      case 'in_progress':
      case 'needs_approval':
      case 'needs_cannot_score_approval':
        filter = {
          id: 'evalState',
          title: 'state',
        }
        break
      case 'evalResponse_pending':
      case 'evalResponse_acknowledged':
      case 'evalResponse_appealed':
        filter = {
          id: 'evalResponse',
          title: 'evalResponseState',
        }
        break
      case 'beginTime':
      case 'endTime':
        filter = {
          id: 'timeRange',
          title: 'timeRange',
        }
        break
      case 'timeZone':
        filter = {
          id: 'timeZone',
          title: 'tz',
        }
        break
      case 'surveyId':
        filter = {
          id: 'surveyName',
          title: 'postCallSurveyName',
        }
        break
      case 'searchText':
      case 'textSearchDocumentTypes':
      case 'ignoreSearchTextLocal':
      case 'searchTextLocale':
        filter = {
          id: 'textSearch',
          title: 'textSearch',
        }
        break
      case 'externalParty':
        filter = {
          id: 'externalParty',
          title: 'externalParty',
        }
        break
      case (key.match(/^(expr|caa)_\d+$/) || {}).input: {
        const [field, operator, value] = data[key].split('~')
        switch (field) {
          case 'silenceEvents':
          case 'talkoverEvents':
          case 'pauseEvents':
          case 'holdEvents':
          case 'silenceDuration':
          case 'talkoverDuration':
          case 'pauseDuration':
          case 'holdDuration':
            filter = {
              id: 'event',
              title: 'speechEnergy',
              fields: {
                eventType: field,
                eventOperator: operator,
                eventVal: value,
              },
            }
            break
          case 'score':
            filter = {
              id: 'score',
              title: 'score',
              fields: {
                scoreOperator: operator,
                score: value,
              },
            }
            break
          case 'surveyScore':
            filter = {
              id: 'surveyScore',
              title: 'postCallSurveyScore',
              fields: {
                surveyScore_operator: operator,
                surveyScore_value: value,
              },
            }
            break
          case 'sentiment': {
            const sentimentValue = operator === 'equals' ? 'neutral' : operator === 'lessThan' ? 'negative' : 'positive'
            filter = {
              id: 'sentiment',
              title: 'sentiment',
              fields: {
                sentiment: sentimentValue,
              },
            }
            break
          }
          case 'pnps':
            filter = {
              id: 'pnps',
              title: 'PredictiveNetPromoterScore',
              fields: {
                operator,
                value,
              },
            }
            break
          case 'peval':
            filter = {
              id: 'peval',
              title: 'evalScorePredictions',
              fields: {
                operator,
                value,
              },
            }
            break
          default:
            filter = {
              id: field,
              title: field,
              fields: {
                operator,
                value,
              },
            }
        }
        break
      }
      case (key.match(/^meta_\d+$/) || {}).input: {
        const [metadataKey, metadataOperator, metadataValue] = data[key].split('~')
        filter = {
          id: 'metadata',
          title: 'customData',
          fields: {
            key: decodeURIComponent(metadataKey),
            operator: metadataOperator,
            value: metadataValue,
          },
        }
        break
      }
      default:
        break
    }
    if (filter !== null) {
      if (typeof filter.fields === 'undefined') {
        filter.fields = {
          [key]: data[key],
        }
      }
      filterList = updateFilterList(filter, filterList)
    }
  })

  return filterList
}

export function formatMediaDisplayState(stateId) {
  switch (stateId) {
    case MEDIA_DISPLAY_STATE.PENDING_UPLOAD:
      return 'pendingUpload'
    case MEDIA_DISPLAY_STATE.UPLOADED:
      return 'uploaded'
    case MEDIA_DISPLAY_STATE.INVALID:
      return 'invalid'
    case MEDIA_DISPLAY_STATE.RECYCLED:
      return 'recycled'
    case MEDIA_DISPLAY_STATE.REMOVED:
      return 'removed'
    default:
      return ''
  }
}

export const checkForDeprecatedNameFilter = filterDetails => {
  return Object.keys(filterDetails).includes('firstName') || Object.keys(filterDetails).includes('lastName')
}

export const getTeamById = (id, teams) => {
  const result = _.find(teams, e => e.id === id)
  return result ? result.name : 'All'
}

export const getGroupByTeamId = (id, groups) => {
  const result = _.find(groups, e => e.parentGroupId === id)
  return result ? result.name : 'All'
}

export const constructAgentsArray = (agents, groups, teams) => {
  const activeAgents = agents.filter(a => a.isActive)
  return activeAgents.map(agent => ({
    ...agent,
    teamName: getTeamById(agent.teamId, teams),
    groupName: getGroupByTeamId(agent.teamId, groups),
  }))
}
